import { Component, OnInit } from '@angular/core';
import { EnvironmentService, InceptionService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  standalone: false,
})
export class ScrollToTopComponent implements OnInit {
  constructor(
    private inceptionService: InceptionService,
    private environmentService: EnvironmentService
  ) {}

  ngOnInit() {
    setTimeout(
      () =>
        this.environmentService.isProximusPlusMobileApp &&
        this.inceptionService.scrollToElement('#scrollToTop')
    );
  }
}
